import React, { Fragment } from "react";
import { Grid } from "@material-ui/core";
import _ from "lodash";
import styled from "styled-components";
import { guaranteeTypeList } from "constants/guaranteeTypes";
import { recourseTypeList } from "constants/recourseTypes";

import {
  ChildSectionTitle,
  SideLabelAutoCompleteWithRefInput,
  SideLabelTextWithRefInput,
  SideLabelTextAreaWithRefInput,
  SideLabelIntegerWithRefInput,
  SideLabelPercentWithRefInput,
  SideLabelPercentInput,
  SideLabelRadioButtonGroup
} from "../FormSectionComponents";

const RecourseGrid = styled(Grid)`
  &&& {
    width:1200px;
  }
  `;
const yesNoList = [
  { id: 1, value: true, name: "Yes" },
  { id: 0, value: false, name: "No" }
];

class RecourseChildSection extends React.Component {
  render() {
    const { isEditing, setFieldValue, isQuote } = this.props;

    return (
      <RecourseGrid container alignItems="center" direction="column">
        {!isQuote && <>
          <SideLabelAutoCompleteWithRefInput
            label="Guaranty Type"
            id="dropdownForGuarantyType"
            options={guaranteeTypeList}
            refFieldName="recourse.guaranteeTypeRef"
            selectName="name"
            selectValue="value"
            fieldName="recourse.guaranteeTypeId"
            hasBorder
            isDisabled={!isEditing}
          />
          <SideLabelTextAreaWithRefInput
            label="Guarantee Waiver"
            hasBorder
            placeholder="Guarantee Waiver"
            fieldName="recourse.guaranteeWaiver"
            isDisabled={!isEditing}
          />
        </>}
        {isQuote && <>
          <SideLabelAutoCompleteWithRefInput
            label="Recourse"
            id="dropdownForRecourse"
            options={recourseTypeList}
            refFieldName="recourse.recourseTypeRef"
            selectName="name"
            selectValue="value"
            fieldName="recourse.recourseTypeId"
            hasBorder
            isDisabled={!isEditing}
          />
          <SideLabelPercentInput label="Recourse Amount" placeholder="Recourse Amount" fieldName="recourse.amount" isDisabled={!isEditing} decimalScale={2} />
          <SideLabelRadioButtonGroup label="Burndown" fieldName="recourse.burndown" isDisabled={!isEditing} setFieldValue={setFieldValue} options={yesNoList} />
                    </>}

        <SideLabelTextAreaWithRefInput
          label="Carveouts"
          hasBorder
          placeholder="Carveouts"
          fieldName="recourse.carveouts"
          isDisabled={!isEditing}
        />
        <SideLabelTextAreaWithRefInput
          label="Misc."
          placeholder="Misc."
          fieldName="recourse.misc"
          isDisabled={!isEditing}
        />
      </RecourseGrid>
    );
  }
}
export default RecourseChildSection;
